import React, { type ComponentProps } from 'react';

import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuTopDownCategoriesItemDescription = (props: ComponentProps<typeof BodyText>) => {
  const { children, ...restProps } = props;

  return (
    <BodyText sizeMatch={['14']} {...restProps}>
      {children}
    </BodyText>
  );
};
